export const LOG_LOCATION = 'spa-apps.common.redirect.last-visited-project-page';

export const SEARCH_FILTER = 'search';

export const SHOW_PROJECT_BUILDER_FILTER = 'showProjectBuilder';
